import React from 'react';
import './App.scss';
import {styled} from '@mui/material/styles';
import meSrc from './assets/me_g.png';
import {HomeContent} from "./components/HomeContent";
import pattern from './assets/pattern.svg';
import {Typography} from '@mui/material';
import theme from "./theme";
import {useCachedImage} from "./useCachedImage";

function App() {
    const Me = styled('img')(() => ({
        height: '70%',
        margin: '2vh 8vw',
        [theme.breakpoints.down('md')]: {
            height: '40%',
        },
    }));

    const meCached = useCachedImage("me", meSrc);

    return (
        <div className="App">
            {/* Pattern layer */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${pattern})`,
                    backgroundRepeat: 'repeat',
                    zIndex: 0,
                    overflow: "hidden"
                }}
            />

            <div
                onDragStart={(e) => e.preventDefault()}
                style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    position: "absolute",
                    zIndex: 1,
                }}>
                <Me src={meCached ?? meSrc} alt="me"/>
            </div>

            <div style={{
                position: 'absolute',
                bottom: '2vh',
                left: '2vw'
            }}>
                <Typography variant={"h6"} color={"text.secondary"}>
                    © {new Date().getFullYear()} Cristian Hilohi
                </Typography>
            </div>
            <HomeContent/>
        </div>
    );
}

export default App;
